import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';
import { SelfProfile } from '../models/self-profile.model';

@Injectable({
  providedIn: 'root',
})
export class SelfProfileService {
  private readonly http = inject(HttpClient);

  getProfile(idUser: number): Observable<ApiResponse<SelfProfile>> {
    return this.http.get<ApiResponse<SelfProfile>>(`/api/v1/profiles/${idUser}`);
  }

  getProfileByStudentCode(studentCode: string) {
    return this.http.get<ApiResponse<SelfProfile>>(`/api/v1/profiles/by-code/${encodeURIComponent(studentCode)}`);
  }
}
